/**
 * 正式基准引用实体类型枚举。
 */
export enum DatumReferenceEntityKind {
  /** 正式基准面。 */
  Plane = 'datum-plane',
  /** 正式基准轴。 */
  Axis = 'datum-axis',
  /** 正式基准点。 */
  Point = 'datum-point',
}

/**
 * 构建正式基准引用实体 ID。
 *
 * @param kind 正式基准引用类型。
 * @param numericId 数值 ID。
 * @returns 序列化后的引用实体 ID。
 */
export function buildDatumReferenceEntityId(
  kind: DatumReferenceEntityKind,
  numericId: number,
): string {
  return `${kind}:${numericId}`;
}

/**
 * 解析正式基准引用实体 ID。
 *
 * @param entityId 引用实体 ID。
 * @param kind 目标正式基准类型。
 * @returns 数值 ID；不匹配时返回 `null`。
 */
export function parseDatumReferenceEntityId(
  entityId: string,
  kind: DatumReferenceEntityKind,
): number | null {
  const prefix = `${kind}:`;
  if (!entityId.startsWith(prefix)) {
    return null;
  }
  const numericId = Number(entityId.slice(prefix.length));
  return Number.isFinite(numericId) ? numericId : null;
}
